// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3RLbr","colMin":"styles_colMin__2SG6y","colCheckbox":"styles_colCheckbox__E8Vyv"};